import { render, staticRenderFns } from "./Open.vue?vue&type=template&id=35575503&scoped=true&"
import script from "./Open.vue?vue&type=script&lang=js&"
export * from "./Open.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35575503",
  null
  
)

export default component.exports